import truncate from 'lodash/truncate'
import { Icon } from '@manychat/manyui'

import { AttachmentBlockAttachmentType } from 'common/builder/blocks/blockConstants'
import { IBlockRemoteImage, IEmailImageBlock } from 'common/builder/blocks/blockInterfaces'
import {
  ConverterRule,
  EmailContentRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { EmailContentAttachmentSizeConverter } from 'common/builder/components/chart/FlowChart/lib/utils/EmailContentAttachmentSizeConverter'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { AttachmentAppearance } from 'common/builder/components/chart/FlowChart/types/AttachmentAppearance'
import {
  EmailContentAttachment,
  EmailContentAttachmentSize,
  EmailContentType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'
import { BlockType } from 'common/builder/constants/BlockType'

export const EmailAttachmentContentConverterRule: ConverterRule<
  IEmailImageBlock,
  EmailContentAttachment,
  EmailContentRulePayload
> = {
  predicate: (entity: IEmailImageBlock) =>
    entity?.type === BlockType.EMAIL_IMAGE &&
    entity?.image?.type === AttachmentBlockAttachmentType.EXTERNAL_IMAGE,
  convert: (entity: IEmailImageBlock, { fields, flowChartButtons }) => {
    const size = EmailContentAttachmentSizeConverter.getFromEmailImageSizePreset(
      entity.settings?.image_size?.value,
    )

    let title = replaceFieldsInString((entity.image as IBlockRemoteImage)?.image_url || '', fields)

    if (size === EmailContentAttachmentSize.S) {
      title = ''
    } else if (size === EmailContentAttachmentSize.M) {
      title = truncate(title, { length: 20 })
    }

    return {
      id: entity.id,
      type: EmailContentType.ATTACHMENT,
      data: {
        attachment: {
          icon: Icon.Image,
          title: title,
          appearance: AttachmentAppearance.EXTERNAL,
        },
        size,
        buttons: getButtonsFromMap(entity.buttons, flowChartButtons),
      },
    }
  },
}
